<template>
  <ul class="details-contacts" v-if="client">
    <li>
      <div class="form-row">
        <label class="lb">CODE</label>
        <div class="inputs">
          <input type="text" class="form-control" v-model="postData.code">
        </div>
      </div>
      <div class="form-row">
        <label class="lb">EMAIL</label>
        <div class="inputs">
          <input type="email" class="form-control" v-model="postData.email">
        </div>
      </div>
      <div class="form-row">
        <label class="lb">PHONE</label>
        <div class="inputs">
          <input type="tel" class="form-control" v-model="postData.phone">
        </div>
      </div>
      <div class="form-row">
        <label class="lb">PRICE TIER</label>
        <div class="inputs">
          <v-select v-model="postData.price_tier" :options="allPriceTiers" class="form-control" :clearable="false" :reduce="item => item.code"  label="name"></v-select>
        </div>
      </div>
    </li>
    <li>
      <div class="form-row">
        <label class="lb">ADDRESS 1</label>
        <div class="inputs">
          <input type="text" class="form-control" v-model="postData.address_1">
        </div>
      </div>
      <div class="form-row">
        <label class="lb">ADDRESS 2</label>
        <div class="inputs">
          <input type="text" class="form-control" v-model="postData.address_2">
        </div>
      </div>
      <div class="form-row">
        <label class="lb">SUBURB</label>
        <div class="inputs">
          <input type="text" class="form-control" v-model="postData.suburb">
        </div>
      </div>
      <div class="form-row">
        <label class="lb">CLIENT MANAGER</label>
        <div class="inputs">
          <v-select v-model="postData.client_manager_id" :options="clientManagers" class="form-control" :reduce="item => item.id"
                    label="full_name" :searchable="true" :placeholder="'- Select client manager'"></v-select>
        </div>
      </div>
    </li>
    <li>
      <div class="form-row">
        <label class="lb">STATE</label>
        <div class="inputs">
          <v-select v-model="postData.state" :options="allStates" class="form-control" :reduce="item => item.code"
                    label="name" :searchable="true" :placeholder="'- Select state'"></v-select>
          <div v-if="postData.state == 'Other'">
            <br/>
            <input type="text" class="form-control" placeholder="Please enter the state" v-model="postData.other_state">
          </div>
        </div>
      </div>
      <div class="form-row">
        <label class="lb">POSTCODE</label>
        <div class="inputs">
          <input type="text" class="form-control" v-model="postData.postcode">
        </div>
      </div>
      <div class="form-row">
        <label class="lb">MANAGER</label>
        <div class="inputs">
          <v-select v-model="postData.manager_id" :options="client.members" class="form-control" :reduce="item => item.id"
                    label="full_name" :searchable="true" :placeholder="'- Select manager'"></v-select>
        </div>
      </div>
      <div class="text-right">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="button" class="btn btn btn-primary w180" @click="saveClient(null)">Save</button>
        </template>
      </div>
    </li>
  </ul>
</template>

<script>
  import {mapState} from 'vuex'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import ServiceClient from '@/services/client'

  export default {
    components: {
      BeatLoader,
    },
    data () {
      return {
        state: '',
        status: 'pending',
        postData: {
          code: '',
          email: '',
          phone: '',
          address_1: '',
          address_2: '',
          suburb: '',
          state: '',
          other_state: '',
          postcode: '',
          manager_id: '',
          client_manager_id: '',
          price_tier: 'tier1'
        }
      }
    },
    watch: {},
    computed: mapState({
      allStates: state => state.option.stateWithOtherOpts,
      allPriceTiers: state => state.option.priceTierOpts,
      client: state => state.client.client,
      clientManagers: state => state.option.client_managers
    }),
    created () {},
    mounted () {
      this.init();
    },
    methods: {
      init () {
        let self = this;
        self.showModalEdit = false;
        self.populateData();
        /*
        self.$store.dispatch('GET_CLIENT', self.quoteId)
          .then(() => {
            self.populateData();
          });
        */
      },
      populateData () {
        let self = this;

        for(let f in self.postData){
          if(typeof self.client[f] != 'undefined')
            self.postData[f] = self.client[f];
        }

        if (self.client.manager)
          self.postData.manager_id = self.client.manager.id;
      },
      saveClient (updateData) {
        let self = this;
        if (self.state == 'saving') {
          return;
        }
        if (updateData == null) {
          updateData = {};
          Object.assign(updateData, self.postData);
        }

        self.state = 'saving';
        ServiceClient.save(self.client.id, updateData, client => {
          let now = new Date().getTime();
          if(now - self.updated_dtm > 5*1000){
            self.$notify({
              type: 'success',
              text: 'Client updated'
            });
            self.updated_dtm = now;
          }
          self.state = '';
          self.$store.dispatch('UPDATE_CLIENT', client).then(() => {
            self.populateData();
          });
        }, () => {
          self.state = '';
        });
      },
    }
  }
</script>
